import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

const getDefaultSelectedSchedule = () => {
  return {
    number: null,
    lineId: null,
    strategy: "DAILY",
    days: 10,
    reservationPriceCurrency: "TRY",
    trainInfoSchedules: [
      {
        type: null,
        name: null,
        // işlem özellikleri
        reservationEnabled: true,
        ticketingEnabled: false,
        startDate: null,
        endDate: null,
        trainInfo: {},
      },
    ],
    reversed: false,
    orerSchedules: [],
    carSchedules: [],
    pricingSchedules: [],
    saleablePassengerTypeIds: [],
    fareFamilyRestrictions: [],
    availableSalesChannels: [],
    trainWorksInReversed: [],
    bookingClassCapacities: [],
    saleParkourRestrictions: [],
    selectedCaptchaSalesChannels: [],
  };
};

export default {
  state: () => ({
    schedules: [],
    // lineStations:[], fareFamilies:[], passengerTypes:[], saleChannels:[] ,selectedCaptchaSalesChannels:[]
    selectedSchedule: getDefaultSelectedSchedule(),
  }),

  mutations: {
    setSchedules(state, schedules) {
      Vue.set(state, "schedules", schedules);
    },
    setSelectedSchedule(state, selectedSchedule) {
      Vue.set(state, "selectedSchedule", selectedSchedule);
    },
    setDefaultSelectedSchedule(state) {
      Vue.set(state, "selectedSchedule", getDefaultSelectedSchedule());
    },
  },

  actions: {
    loadSchedules: (context) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/schedules/entity")
          .then((response) => {
            // context.commit("setSchedules", response.data);
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadPublishedSchedules: (context) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/schedules/entity/published")
          .then((response) => {
            // context.commit("setSchedules", response.data);
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadSelectedScheduleHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/schedules/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    saveSchedule: (context, schedule) => {
      return (
        axios
          //TODO
          .post(context.getters.getMcServiceUrl + "/schedules/entity", schedule)
          .then((response) => {
            return response;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },

    getTrainStationsBySchedules: (context, schedules) => {
      return (
        axios
          //TODO
          .post(context.getters.getMcServiceUrl + "/schedules/get-train-stations-by-schedules", schedules)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadSchedule: (context, schedule) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/schedules/entity/" + schedule.id)
          .then((response) => {
            let orerSchedules = response.data.orerSchedules;
            orerSchedules.forEach((scheduleOrer) => {
              scheduleOrer.orer.orerStations.forEach((station) => {
                station.arrivalTime = moment(station.arrivalTime, "HH:mm:ss").add("3", "hour").format("HH:mm:ss");
                station.departureTime = moment(station.departureTime, "HH:mm:ss").add("3", "hour").format("HH:mm:ss");
              });
            });
            orerSchedules.sort((a, b) => (new Date(a.endDate) < new Date(b.endDate) ? 1 : -1));
            context.commit("setSelectedSchedule", response.data);
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadActiveSchedulesWithCarAndOrerInfoByScheduleId: (context, scheduleId) => {
      return (
        axios
          //TODO
          .get(context.getters.getMcServiceUrl + "/schedules/load-active-schedules-with-car-and-orer-info/" + scheduleId)
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadDraftSchedule: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/schedules/entity/draft/" + intentId).then((response) => {
        context.commit("setSelectedSchedule", response.data);
        return response.data;
      });
    },
    publishSchedule: (context, schedule) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/schedules/publish/" + schedule.intentId)
        .then((response) => {
          if (response.data) {
            response.data.intentId = 0;
          }
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    recallSchedule: (context, schedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/schedules/recall/" + schedule.intentId).then((response) => {
        return response.data;
      });
    },
    rejectSchedule: (context, schedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/schedules/reject/" + schedule.intentId).then((response) => {
        return response.data;
      });
    },
    cancelSchedule: (context, schedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/schedules/cancel/" + schedule.intentId).then((response) => {
        return response.data;
      });
    },
    deleteSchedule: (context, schedule) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/schedules/entity/" + schedule.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          schedule.intents = intents;
          schedule.intentId = response.data.id;
          return schedule;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSchedule: (context, schedule) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/schedules/draft/" + schedule.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
  },

  getters: {
    getSchedules: (state) => {
      return state.schedules;
    },
    getSelectedSchedule: (state) => {
      return state.selectedSchedule;
    },
  },
};
